// import queryString from "query-string";
import React, { useContext, useState } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownSearch,
  CustomView,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../api";
import values from "../../../../values";
import Context from "../../../../context";
import {
  ICityItem,
  IItem,
  IProvinceItem,
} from "../../../../types/common.interface";
import {
  TICKET_STATUS,
  ticketUserType,
} from "../../../../values/dropdownItems";
import { useTranslation } from "react-i18next";

const FilterSuperAgent = () => {
  // ============================== Value Validation ================================

  const { requestTicket, setRequestTicket } = React.useContext(
    Context.TicketScreen
  );
  const [selectedUserType, setSelectedUserType] = useState<any>();
  const [selectedTicketStatus, setSelectedTicketStatus] = useState<any>();

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, requestTicket?.filters?.province],
    () =>
      api.get.common.getAllCity({
        provinceCode: requestTicket?.filters?.province?.Code,
      })
  );
  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  const { t } = useTranslation();

  // ================================== JSX Content ================================

  return (
    <div className="filter-container">
      <CustomDropdownFilter title={t("filter")} hoverTitle={t("filter")}>
        <CustomView.Row>
          <CustomView.Column medium={12}>
            <p className="filter-labels">{t("userType")}:</p>
            <CustomDropdownSearch
              items={ticketUserType}
              itemName="name"
              defaultItem={selectedUserType}
              onSelectItem={(event: any) => {
                setSelectedUserType(event);
                setRequestTicket({
                  ...requestTicket,
                  filters: {
                    ...requestTicket?.filters,
                    type: event?._id,
                  },
                });
              }}
              placeHolder={t("selectUserType")}
              isLoading={getAllProvince.isLoading}
            />
          </CustomView.Column>
          <CustomView.Column medium={12}>
            <p className="filter-labels">{t("status")}:</p>
            <CustomDropdownSearch
              items={TICKET_STATUS}
              itemName="name"
              defaultItem={selectedTicketStatus}
              onSelectItem={(event: any) => {
                setSelectedTicketStatus(event);
                setRequestTicket({
                  ...requestTicket,
                  filters: {
                    ...requestTicket?.filters,
                    status: event?._id,
                  },
                });
              }}
              placeHolder={t("selectStatus")}
              isLoading={getAllProvince.isLoading}
            />
          </CustomView.Column>
          <CustomView.Column medium={12}>
            <p className="filter-labels">{t("province")}:</p>
            <CustomDropdownSearch
              items={getAllProvince?.data?.result}
              itemName="Name"
              defaultItem={requestTicket?.filters?.province}
              onSelectItem={(event: IProvinceItem) =>
                setRequestTicket({
                  ...requestTicket,
                  filters: {
                    ...requestTicket?.filters,
                    province: event,
                    city: undefined,
                  },
                })
              }
              placeHolder={t("selectProvince")}
              isLoading={getAllProvince.isLoading}
            />
          </CustomView.Column>
          <CustomView.Column medium={12}>
            <p className="filter-labels">{t("city")}:</p>
            <CustomDropdownSearch
              items={getAllCity?.data?.result}
              itemName="Name"
              defaultItem={requestTicket?.filters?.city}
              onSelectItem={(event: ICityItem) =>
                setRequestTicket({
                  ...requestTicket,
                  filters: {
                    ...requestTicket?.filters,
                    city: event,
                  },
                })
              }
              placeHolder={t("selectCity")}
              isLoading={getAllCity.isLoading}
            />
          </CustomView.Column>
        </CustomView.Row>
        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={() => {
              setRequestTicket({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );

  // ?? -----------------------------------------------------------------------------------------------------------
  // ??                                             End JSX Content
  // ?? ===========================================================================================================
};

export default FilterSuperAgent;
